import { Box, CircularProgress, Container, Stack, Typography } from '@mui/material';
import React from 'react';
import { Helmet } from 'react-helmet-async';

import useUsers from '../hooks/useUsers';
import AttendanceTable from '../components/table/AttendanceTable';

const MemberAttendance = () => {
  const { attendance, attendanceLoader, attendanceError } = useUsers();
  return (
    <>
      <Helmet>
        <title> All Members | CaaS </title>
      </Helmet>

      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Attendance
          </Typography>
          <Typography variant="h4" gutterBottom>
            Attendees: {attendance.length}
          </Typography>
        </Stack>
        {attendanceLoader ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', allignItems: 'center', height: '100%' }}>
            <CircularProgress sx={{ color: '#000080' }} />
          </Box>
        ) : (
          <AttendanceTable attendance={attendance} attendanceError={attendanceError} />
        )}
      </Container>
    </>
  );
};

export default MemberAttendance;
